/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { Button } from '.';
import { IOption } from '../../types/components/Settings';
import { ButtonType } from './Button';

interface IOptionButtonsProps {
  onClickCallback?: (option: IOption) => void;
  options?: IOption[];
  bemBlock: string;
}

const OptionsButtons: React.FunctionComponent<IOptionButtonsProps> = ({
  onClickCallback,
  options,
  bemBlock,
}: IOptionButtonsProps) => {
  const handleOnClick = (option: IOption) => {
    if (onClickCallback) {
      onClickCallback(option);
    }
  };

  return (
    <ul>
      {options?.map((option) => {
        return (
          <Button
            disabled={option.disabled}
            active={option.isSelected}
            onClick={() => {
              if (option.isSelected === false) {
                handleOnClick(option);
              }
            }}
            buttonType={ButtonType.LI}
            text={option.text}
            key={option.key}
            bemBlock={bemBlock}
            bemModifier={option.key}
          />
        );
      })}
    </ul>
  );
};

export default React.memo(OptionsButtons);
